import React, { useState } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/types';

export const popoverConfig = {
  modifiers: [{ name: 'preventOverflow' }],
};

interface RmsPopoverProps {
  overlay: React.ReactElement<any>;
  children: React.ReactElement<any>;
  placement?: Placement;
  dataTestId?: string;
}

const RmsPopover = ({ overlay, children, placement = 'auto', dataTestId = 'popover-trigger' }: RmsPopoverProps) => {
  const [showPopover, setShowPopover] = useState(false);

  return (
    <span onMouseLeave={() => setShowPopover(false)} onMouseEnter={() => setShowPopover(true)} data-testid={dataTestId}>
      <OverlayTrigger overlay={overlay} placement={placement} show={showPopover} popperConfig={popoverConfig}>
        {children}
      </OverlayTrigger>
    </span>
  );
};

export default RmsPopover;
